import { CarvanaThemeDeprecated } from '@carvana/showroom-theme';
import { mergeDeepRight } from 'ramda';

const theme = {
  carvana: {
    red: {
      background: '#FFBDBD'
    },
    gray: {
      darker: '#6d7184'
    },
    dealerMarketplace: {
      purple: '#5c3fe1'
    },
    partnerInventory: {
      teal: '#02BCBC'
    }
  }
};

export default mergeDeepRight(CarvanaThemeDeprecated, theme);
